import { combineReducers } from 'redux';

// reducers
import enquireModal from '../components/EnquireModal/reducer';

const components = { enquireModal };

export default () => combineReducers(components);



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/store/components.js